<h2 class="text-3xl font-semibold text-center text-gray-800 mb-3 uppercase">Carga masiva de clientes desde CSV</h2>
<div class="max-w-full mx-auto mt-8 px-4 py-5 bg-white shadow-md rounded-lg">
  <div class="flex justify-center items-center space-x-4 mt-4">
    <input type="file" id="csvFile" name="csvFile" (change)="onFileSelected($event)" hidden #csvInput>
    <button
      class="px-6 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-600 focus:ring-opacity-50 transition duration-300 ease-in-out"
      (click)="triggerFileInput()">
      Seleccionar archivo CSV
    </button>
    <button
      class="px-6 py-2 bg-gray-200 text-gray-600 rounded-lg hover:bg-gray-300 disabled:bg-gray-400 disabled:text-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-opacity-50 transition duration-300 ease-in-out"
      [disabled]="!selectedFile || isLoading" (click)="uploadFile()">
      Enviar CSV
    </button>
  </div>
</div>

<div *ngIf="isLoading" class="absolute inset-0 flex items-center justify-center bg-white opacity-75">
  <mat-spinner class="text-orange-500 animate-spin" strokeWidth="3" [diameter]="70"></mat-spinner>
</div>